export default __webpack_public_path__ + "static/media/Trim.146e4314.svg";